module.exports = {
	"name": "react-videojs",
	"version": "0.0.1",
	"description": "react videojs wrapper",
	"main": "index.js",
	"scripts": {
		"start": "webpack-dev-server -c --port=7788",
		"build": "babel src --out-dir dist && webpack -p",
		"deploy": "npm run build && github-pages-deploy",
		"test": "echo \"Error: no test specified\" && exit 1"
	},
	"github-pages-deploy": {
		"src": "example"
	},
	"repository": {
		"type": "git",
		"url": "git+https://github.com/esportsguy/react-videojs.git"
	},
	"peerDependencies": {
		"react": "^0.14.0",
		"react-dom": "^0.14.0"
	},
	"keywords": [
		"react-component",
		"videojs",
		"video",
		"react"
	],
	"author": "Wang Zuo",
	"license": "ISC",
	"bugs": {
		"url": "https://github.com/esportsguy/react-videojs/issues"
	},
	"homepage": "https://github.com/esportsguy/react-videojs#readme",
	"dependencies": {
		"blacklist": "^1.1.2",
		"classnames": "^2.2.0",
		"object-assign": "^4.0.1"
	},
	"devDependencies": {
		"babel-core": "^6.2.1",
		"babel-loader": "^6.2.0",
		"babel-preset-es2015": "^6.1.18",
		"babel-preset-react": "^6.1.18",
		"github-pages-deploy": "0.0.3",
		"json-loader": "^0.5.3",
		"webpack": "^1.12.8"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 7
 ** module chunks = 0
 **/